// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchInputStyles } from "@conklin/Overrides/Widgets/Header/SearchInput";
import {
    color,
    getSystemColor,
    mergeWithCss,
    searchBoxFieldClickableStyles,
    styledScrollbar,
    xScreen,
} from "@conklin/XDL/Utilities";
import { css } from "styled-components";

searchInputStyles.autocompleteWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        max-height: 400px;
        width: 100%;
        overflow: hidden;

        ${xScreen("lte", "md")} {
            max-height: 90vh;
        }

        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

searchInputStyles.input = {
    ...mergeWithCss(searchBoxFieldClickableStyles, {
        cssOverrides: {
            formInputWrapper: css`
                &&&& input {
                    padding-right: 50px;
                }
            `,
        },
    }),
};

searchInputStyles.autocompleteColumnWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 274px;
        padding: 12px;
        ${xScreen("lte", "md")} {
            width: 50%;
        }
        ${xScreen("lte", "sm")} {
            border-right: 0;
            width: 100%;
            padding: 16px;
        }
    `,
};

searchInputStyles.autocompleteColumnProductWrapper = {
    css: css`
        padding: 12px;
        width: 527px;
        ${styledScrollbar(8)}
        height: 100%;
        ${({ hasContent }: any) =>
            hasContent
                ? css`
                      border-left: 1px solid ${getSystemColor("common.ui5")};
                      ${xScreen("lte", "md")} {
                          width: 50%;
                      }
                  `
                : css`
                      ${xScreen("lte", "md")} {
                          width: 100%;
                      }
                  `};

        ${xScreen("lte", "md")} {
            height: unset;
        }

        ${xScreen("lte", "sm")} {
            padding: 16px;
            border-left: none;
            width: auto;
            order: 2;
        }
    `,
};

searchInputStyles.autocompleteColumnProductMobileDivider = {
    css: css`
        display: none;
        ${xScreen("lte", "sm")} {
            height: 1px;
            width: calc(100% - 32px);
            border-top: 1px solid ${color("common.border")};
            margin: 16px auto;
            display: block;
        }
    `,
};

searchInputStyles.popup = {
    triggerWrapper: {
        css: css`
            display: block;
            align-items: center;
            ${xScreen("lte", "md")} {
                max-height: 100%;
            }
        `,
    },
    tooltipContent: {
        css: css`
            ${xScreen("lte", "md")} {
                width: 100%;
            }
            padding: 0;
            max-width: 100vw;
            border-radius: 0;
        `,
    },
};
